var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
import { errorServiceInstance } from "./error.service";
import * as Bluebird from "bluebird";
import h from "../helper/helper";
import idb from "idb"; // tslint:disable-line:no-unused-variable
var REINIT_CACHE_TIMEOUT = 2000;
var cachesDisabled = false;
var openDatabase = function () {
    return idb.open("whispeerCache", 10, function (upgradeDB) {
        var objectStore = upgradeDB.createObjectStore('cache', { keyPath: "id" });
        objectStore.createIndex("created", "created", { unique: false });
        objectStore.createIndex("used", "used", { unique: false });
        objectStore.createIndex("type", "type", { unique: false });
        objectStore.createIndex("size", "size", { unique: false });
    }).catch(function (e) {
        console.warn("Disabling indexedDB caching due to error", e);
        cachesDisabled = true;
        return Promise.reject(e);
    });
};
var initCache = function () { return cachesDisabled = false; };
try {
    indexedDB.deleteDatabase("whispeer");
}
catch (e) { }
var followCursorUntilDone = function (cursorPromise, action) {
    return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
        var cursor;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, cursorPromise];
                case 1:
                    cursor = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!cursor) return [3 /*break*/, 4];
                    action(cursor);
                    return [4 /*yield*/, cursor.continue()];
                case 3:
                    cursor = _a.sent();
                    return [3 /*break*/, 2];
                case 4: return [2 /*return*/];
            }
        });
    }); });
};
var Cache = /** @class */ (function () {
    function Cache(name, options) {
        this.name = name;
        this.cacheDisabled = false;
        this.options = options || {};
        this.options.maxEntries = this.options.maxEntries || 100;
        this.options.maxBlobSize = this.options.maxBlobSize || 1 * 1024 * 1024;
    }
    Cache.deleteDatabase = function () {
        cachesDisabled = true;
        return idb.delete("whispeerCache").then(function () {
            setTimeout(function () {
                initCache();
            }, REINIT_CACHE_TIMEOUT);
        });
    };
    Cache.sumSize = function (arr) {
        return arr.reduce(function (prev, cur) {
            return prev + cur.size;
        }, 0);
    };
    Cache.prototype.store = function (id, data, blobs) {
        var _this = this;
        if (this.isDisabled()) {
            return Bluebird.resolve();
        }
        if (blobs && !h.array.isArray(blobs)) {
            blobs = [blobs];
        }
        if (blobs && this.options.maxBlobSize !== -1 && Cache.sumSize(blobs) > this.options.maxBlobSize) {
            return Bluebird.resolve();
        }
        var cacheEntry = {
            data: JSON.stringify(data),
            created: new Date().getTime(),
            used: new Date().getTime(),
            id: this.getID(id),
            type: this.name,
            size: 0,
            blobs: []
        };
        if (blobs) {
            cacheEntry.blobs = blobs;
            cacheEntry.size = Cache.sumSize(blobs);
        }
        return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        console.info("Storing in indexeddb " + this.getID(id));
                        tx = db.transaction('cache', 'readwrite');
                        tx.objectStore('cache').put(cacheEntry);
                        return [4 /*yield*/, tx.complete];
                    case 2:
                        _a.sent();
                        db.close();
                        return [2 /*return*/];
                }
            });
        }); }).catch(errorServiceInstance.criticalError);
    };
    Cache.prototype.contains = function (id) {
        var _this = this;
        if (this.isDisabled()) {
            return Bluebird.resolve(false);
        }
        return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, count;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction("cache", "readonly");
                        return [4 /*yield*/, tx.objectStore("cache").count(this.name + "/" + id)];
                    case 2:
                        count = _a.sent();
                        db.close();
                        return [2 /*return*/, count > 0];
                }
            });
        }); });
    };
    Cache.prototype.get = function (id) {
        var _this = this;
        if (this.isDisabled()) {
            return Bluebird.reject(new Error("Cache is disabled " + this.name));
        }
        /*
        var cacheResult = this._db.cache.where("id").equals(this.name + "/" + id);

        this._db.cache.where("id").equals(this.name + "/" + id).modify({ used: new Date().getTime() });
        */
        return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction("cache", "readonly");
                        return [4 /*yield*/, tx.objectStore("cache").get(this.name + "/" + id)];
                    case 2:
                        data = _a.sent();
                        if (typeof data === "undefined") {
                            throw new Error("cache miss for " + this.getID(id));
                        }
                        data.data = JSON.parse(data.data);
                        data.blobs = data.blobs || [];
                        data.blobs = data.blobs.map(function (blob) {
                            if (typeof blob === "string") {
                                return h.dataURItoBlob(blob);
                            }
                            return blob;
                        });
                        if (data.blobs.length === 1) {
                            data.blob = data.blobs[0];
                        }
                        db.close();
                        return [2 /*return*/, data];
                }
            });
        }); });
    };
    /**
     * get all cache entries as a dexie collection.<
     * @return {Bluebird<any>} Promise containing all cache entries as a dexie collection.
     */
    Cache.prototype.all = function () {
        if (this.isDisabled()) {
            return Bluebird.resolve([]);
        }
        var entries = [];
        return this.cursorEach(function (cursor) { return entries.push(cursor.value); }, "readonly").then(function () { return entries; });
    };
    Cache.prototype.getID = function (id) {
        return this.name + "/" + id;
    };
    /**
     * delete a certain cache entry.
     * @param  {string}        id id of the entry
     * @return {Bluebird<any>}    [description]
     */
    Cache.prototype.delete = function (id) {
        var _this = this;
        if (this.isDisabled()) {
            return Bluebird.resolve();
        }
        return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction("cache", "readwrite");
                        return [4 /*yield*/, tx.objectStore("cache").delete(this.getID(id))];
                    case 2:
                        _a.sent();
                        db.close();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Cache.prototype.deleteAll = function () {
        if (this.isDisabled()) {
            return Bluebird.resolve();
        }
        var deleteRequests = [];
        return this.cursorEach(function (cursor) { return deleteRequests.push(cursor.delete()); }, "readwrite").then(function () { return Bluebird.all(deleteRequests); });
    };
    Cache.prototype.cursorEach = function (action, transactionType) {
        var _this = this;
        return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, cursorPromise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction("cache", transactionType);
                        cursorPromise = tx.objectStore("cache").index("type").openCursor(this.name);
                        return [4 /*yield*/, followCursorUntilDone(cursorPromise, action)];
                    case 2:
                        _a.sent();
                        db.close();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Cache.prototype.isDisabled = function () {
        return cachesDisabled || this.cacheDisabled;
    };
    Cache.disable = function () {
        cachesDisabled = true;
    };
    Cache.prototype.disable = function () {
        this.cacheDisabled = true;
    };
    return Cache;
}());
export default Cache;



//////////////////
// WEBPACK FOOTER
// ./js/services/Cache.ts
// module id = 4PxX
// module chunks = 1 2 3 4 5 6